import { connect } from 'react-redux';

import {
    SearchItemContainer as SourceSearchItemContainer,
    mapDispatchToProps,
    mapStateToProps,
} from 'SourceComponent/SearchItem/SearchItem.container';

export {
    mapDispatchToProps,
    mapStateToProps,
};

export class SearchItemContainer extends SourceSearchItemContainer {
    static propTypes = {
        closeSearch: this.propTypes
    }

    handleItemClick() {
        const { hideActiveOverlay, closeSearch } = this.props;

        closeSearch();

        hideActiveOverlay();
    }

    getImgSrc() {
        const {
            product: {
                small_image: { url = '' } = {},
            },
        } = this.props;

        return url;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchItemContainer);
